import template from './business-floor.jade';
import validation from '../../../services/validation';
import { selectAnalyticsOfferStatus } from '../../../../../../shared/selectors/analytics';
import { trackRequiredFieldFill } from '../../../../../../shared/utils/tracking/requiredFields';

export default angular.module('cian.addForm.businessFloor', []).directive('cianAfAboutObjectBusinessFloor', [
  '$rootScope',
  'store',
  ($rootScope, store) => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
      required: '=',
    },
    link: {
      pre(scope, element, attrs, ctrl) {
        ctrl.minFloorStrict = attrs.minFloorStrict !== 'false';
      },
    },
    controller(deviceService) {
      'ngInject';
      this.isMobile = deviceService.isMobile;

      this.floorNumberBlured = false;
      this.minFloorNumber = this.minFloor;
      this.maxFloorNumber = 999;

      this.getMinFloorsCount = () => {
        return this.ad.floorNumber ? Math.max(1, this.ad.floorNumber) : 1;
      };

      this.isRequired = () => this.required && this.form.floorNumber.$invalid;

      this.floorNumberValidation = validation(this.form, 'floorNumber', {
        parse: 'Введите число',
        required: 'Введите этаж',
        min: `Этаж должен быть больше ${this.minFloorNumber}`,
        max: 'Допустимо не более 3 символов',
        notZero: 'Введите -1 или -2 для подвала или полу-подвала',
      });

      this.blurField = () => {
        const state = store.getState();
        const category = selectAnalyticsOfferStatus(state);

        this.floorNumberBlured = true;

        trackRequiredFieldFill(category, 'floor');
      };

      this.floorNumberValidationInvalid = () => {
        return this.floorNumberValidation.invalid();
      };

      this.floorNumberValidationShowTooltip = () => {
        return this.floorNumberValidation.invalid();
      };

      $rootScope.$on('addform.submit', () => {
        this.floorNumberBlured = true;
      });
    },
    controllerAs: 'businessFloorCtrl',
    template,
  }),
]).name;
